import { FunctionComponent } from 'react';
import { trackFeature } from '@/utils/adobeLaunch';
import { FacebookMessenger } from '@/components/common/icons/FacebookMessenger';
import { Mail } from '@/components/common/icons/Mail';
import { WhatsApp } from '@/components/common/icons/WhatsApp';
import './SharingSocial.scss';

const track = (what: string) => {
  trackFeature(`sharing-${what}`);
};

interface Props {
  url: string;
  imageUrl?: string;
}

export const SharingSocial: FunctionComponent<Props> = ({ url }) => (
  <ul className="sharing-social">
    <li className="sharing-social__item">
      <a
        className="sharing-social__network"
        href={`whatsapp://send?text=${encodeURIComponent(url)}`}
        onClick={() => track('whatsapp')}
        target="_parent"
      >
        <div className="sharing-social__network-icon sharing-social__whatsapp">
          <WhatsApp width="1.9em" height="1.9em" />
        </div>
        <span className="sharing-social__network-name">WhatsApp</span>
      </a>
    </li>
    <li className="sharing-social__item">
      <a
        onClick={() => track('email')}
        className="sharing-social__network"
        href={`mailto:?body=${encodeURIComponent(url)}`}
        target="_parent"
      >
        <div className="sharing-social__network-icon sharing-social__mail">
          <Mail width="1.625em" height="1.625em" />
        </div>
        <span className="sharing-social__network-name">E-Mail</span>
      </a>
    </li>
    <li className="sharing-social__item">
      <a
        className="sharing-social__network"
        href={`fb-messenger://share?link=${encodeURIComponent(url)}`}
        onClick={() => track('facebook-messenger')}
        target="_parent"
      >
        <div className="sharing-social__network-icon sharing-social__facebook-messenger">
          <FacebookMessenger width="1.9em" height="1.9em" />
        </div>
        <span className="sharing-social__network-name">Messenger</span>
      </a>
    </li>
  </ul>
);
